import { parseISO, isValid } from 'date-fns';
import * as t from 'io-ts'

export const utcString = new t.Type<Date, Date, unknown>(
    'utcString',
    (input: unknown): input is Date => typeof input === 'string' && isValid(parseISO(input)),
    (input, context) => typeof input === 'string' && isValid(parseISO(input)) 
        ? t.success(parseISO(input)) 
        : t.failure(input, context),
    t.identity
);

export const epochNumber = new t.Type<Date, Date, unknown>(
    'epochNumber',
    (input: unknown): input is Date => typeof input === 'number' && isValid(new Date(input)),
    (input, context) => typeof input === 'number' && isValid(new Date(input)) 
        ? t.success(new Date(input)) 
        : t.failure(input, context),
    t.identity
);

export const dateObject = new t.Type<Date, Date, unknown>(
    'dateObject',
    (input: unknown): input is Date => input instanceof Date,
    (input, context) => (input instanceof Date)
        ? t.success(input as Date)
        : t.failure(input, context),
    t.identity
);

/**
 * @description Codec for timestamp validating and parsing UTC strings, epoch numbers, and Date objects
 * @returns Date object
 */
const timestampCodec = t.union([dateObject, utcString, epochNumber]);

export default timestampCodec;